module.exports = __webpack_public_path__ + "static/media/catalogue_02@2x.509ebef3.png";